export default {
  hasCompanyInfo: (state) =>
    state.hasOwnProperty("company") && Object.keys(state.company).length > 0,
  color: (state) => {
    if (!state.company || !state.company.base_hexcolor) return "#1551b1";
    return state.company.base_hexcolor;
  },
};
